module.exports = __webpack_public_path__ + "_/skins/ZaxonRemake1-0-c7333f1f8fd296f4dd68f9b138d22e5d.wsz";